// extracted by mini-css-extract-plugin
export default {"1200":"(min-width: 1200px)","sidebar":"kAGU9ZxHrcP1V60VXtpD","forehead":"szBds91pcBPb2lD3XIRg","card":"iwTIPoAfkFZfXQWWjIxn"};